// Генерація nonce
export const generateNonce = (): string => {
  return Math.random().toString(36).substring(2, 15);
};

// Отримання nonce з метатегу
export const getNonce = (): string => {
  const meta = document.querySelector('meta[name="csp-nonce"]');
  return meta ? meta.getAttribute('content') || '' : '';
};

// Встановлення nonce в метатег
export const setNonce = (nonce: string): void => {
  let meta = document.querySelector('meta[name="csp-nonce"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('name', 'csp-nonce');
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', nonce);
};
